import type { IconData } from '@stacksjs/iconify-core'

export const egg: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 18a6 6 0 0 0 6-6c0-4.221-3.418-10-6-10S2 7.779 2 12a6 6 0 0 0 6 6m0 2a8 8 0 0 1-8-8C0 7.582 3.582 0 8 0s8 7.582 8 12a8 8 0 0 1-8 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default egg
